<template>
  <div>

    <!-- Small dialog for Process-Quickstart -->
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title>
          <h4 class="primary--text font-weight-medium mt-5 mt-xl-0">
            {{ $t('book/facility:facility.dashboard.processes.process-quickstart-title') }}
          </h4>
        </v-card-title>
        <v-card-text>
          <v-select
              :items="allProcesses"
              item-value="id"
              item-text="name"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="quickStartProcess"
              outlined
              :label="$t('common:process')"
              clearable
              :hide-details="true"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              rounded
              color="grey"
              class="white--text"
              elevation="0"
              @click="dialog = false"
          >
            {{ $t('buttons:cancel') }}
          </v-btn>
          <v-btn
              :disabled="!quickStartProcess"
              rounded
              color="primary"
              elevation="0"
              @click="quickstartProcess"
          >
            {{ $t('book/facility:facility.dashboard.processes.quickstart-process') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Task List -->
    <TaskList
        ref="taskList"
        :headerTitle="$t('common:task-list')"
        :headerBtnText="$t('book/facility:common.start-manual-process')"
        hideHeaderBtn
        showHeaderMenu
        :menuItemText1="$t('book/facility:facility.dashboard.processes.quickstart-process')"
        :menuItemText2="$t('book/facility:common.start-manual-process')"
        @clickedCard="goToTask"
        @clickedHeaderBtn="$refs.manualProcessForm.openDialog(taskList.options, taskList.search, taskList.filter)"
        @updateData="updateTaskList"
        @acceptTask="acceptInvitation($event)"
        @declineTask="declineInvitation($event)"
        @startTask="showGPSPermission($event)"
        @menuItemClicked1="dialog = true"
        @menuItemClicked2="$refs.manualProcessForm.dialog = true"
        :sorts="taskListSorts"
        :filter="taskListFilter"
        :defaultDesc="true"
        defaultSortBy="finishedOn"
        defaultFilterBy="open"
    />

    <TwoButtonDialog
        ref="checkGPSPermission"
        :hide-button="true"
        :dialog-title="$t('common:gps-control')"
        :dialog-text="$t('book/facility:facility.dashboard.gps-dialog')"
        :button1-text="$t('buttons:accept')"
        :button2-text="$t('buttons:decline')"
        @clickedButton1="checkUserLocation($event)"
        @clickedButton2="startProcessJob($event, false)"
    />

    <FacilityManualProcessDialogForm
        ref="manualProcessForm"
    />
     <ProcessShowDialog ref="processShowDialog"/>
  </div>
</template>

<script>
import TaskListService from '@/modules/book/services/process/impl/task-list-service'
import ProcessJobService from '@/modules/book/services/process/impl/process-job-service'
import ProcessService from "@/modules/book/services/process/impl/process-service";
import FacilityService from "@/modules/book/services/facility-service";

import Utils from "@/modules/core/services/utils";
import GPSUtils from "@/modules/core/services/gps-utils";
import DataUtils from "@/modules/core/services/data-utils";

import Process from "@/modules/book/data/process";
import Facility from "@/modules/book/data/facility";

import FacilityManualProcessDialogForm from "../formDialogs/FacilityManualProcessDialogForm"
import TaskList from "@/modules/book/components/TaskList/TaskList"
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";

import ProcessShowDialog from "@/modules/book/components/Process/ProcessShowDialog"
import TaskListUtils from "@/modules/book/services/task-list-utils";

export default {
  name: 'FacilityProcessTab',
  components: {
    FacilityManualProcessDialogForm,
    TaskList,
    TwoButtonDialog,
    ProcessShowDialog
  },
  data() {
    return {
      allProcesses: [],
      quickStartProcess: null,
      dialog: false,
      taskList: {
        options: [],
        search: [],
        filter: null,
        period: null
      }
    }
  },
  computed: {
    taskListSorts() {
      return [
        {label: this.$t('book/facility:facility.dashboard.task-list.sorts.process-name'), value: "processName"},
        {label: this.$t('common:date'), value: "finishedOn"}
      ]
    },

    taskListFilter() {
      return [
        {label: this.$t('book/facility:common.open-processes'), value: 'open'},
      ]
    },
  },
  methods: {
    quickstartProcess() {
      this.$store.commit('book/process/storeUsername', null);
      this.$store.commit('book/process/storeRideCount', null);
      this.$store.commit('book/process/storeFileNumber', null);
      this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/quickstart/${this.$route.params.id}/${this.quickStartProcess}`);
    },
    goToTask(task) {      
      this.$refs.processShowDialog.openDialog(task)      
    },

    updateTaskList(options, search, filter, period) {
      this.taskList.options = options;
      this.taskList.search = search;
      this.taskList.filter = filter;
      this.taskList.period = period;

      if(filter == 'open') {
        this.readOpenProcess(options, search, period)
      }
    },

    readOpenProcess(options, search, period) {
      if(!search) search = '';

      TaskListService.readPageableFacilityOpenTaskListFromAPI(
        this.$route.params.id,
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        period,
        (res) => {
          res.data.taskItems.content.forEach((task) => {
            task.taskStatus = TaskListUtils.getTaskStatus(task);
          })
          this.$refs.taskList.users = res.data.users;
          this.$refs.taskList.fillList(res.data.taskItems)
        }
      )
    },

    startProcessJob(item, gpsCheck) {
      // TODO save users decicion on GPS Check in backend
      if(gpsCheck) {
        this.acceptedGPSCheck = true;
      } else {
        this.acceptedGPSCheck = false;
      }

      ProcessJobService.startProcessJob(item.id, this.acceptedGPSCheck,
        () => {
          this.$router.push(`/${this.$store.state.manager.bookModuleUrl}/process/${item.id}`);
        },
        (error) => {
          this.$logger.info("Error at starting Process Job: " + error);
        }
      )
    },

    showGPSPermission(item) {
      this.$refs.checkGPSPermission.showDialog = true;
      this.$refs.checkGPSPermission.propToGiveThrough = item;
      this.$store.commit("book/process/storeRideCount", null);
      this.$store.commit("book/process/storeFileNumber", null);
    },

    checkUserLocation(item) {
      FacilityService.readFromAPI(item.facilityId,
        (resp) => {
          var response = DataUtils.parseDataToSingleObject(resp.data, Facility);
          var buildingLat = response.buildingLatitude;
          var buildingLng = response.buildingLongitude;

          this.$getLocation({
            enableHighAccuracy: true,
          }).then(coordinates => {
              var userLat = coordinates.lat;
              var userLng = coordinates.lng;

              var distance = GPSUtils.calcDistance(userLat, userLng, buildingLat, buildingLng);
              if(distance == -1){
                Utils.showFailureSnackbar(this.$t('utils:gps.missing-value'))
              }
              if(distance < process.env.VUE_APP_CHECK_IN_LOCATION_RADIUS) {
                this.startProcessJob(item, true);
              } else {
                this.$refs.checkGPSPermission.showDialog = false;
                Utils.showFailureSnackbar(this.$t('utils:gps.distance-error'))
              }
          }).catch((error) => {
            this.$logger.info("Could not access GPS data, because: " + error);
            Utils.showFailureSnackbar(this.$t('utils:gps.access-error'))
          });
        }
      )
    },

    acceptInvitation(item) {
      if(item.isJob) {
        ProcessJobService.acceptProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/facility:facility.dashboard.task-list.snackbar.accept-process'));
          },
          (error) => {
            this.$logger.info("Error at accepting Process Job: " + error);
          }
        )
      }
    },

    declineInvitation(item) {
      if(item.isJob) {
        ProcessJobService.rejectProcessJob(item.id,
          () => {
            this.updateTaskList(this.taskList.options, this.taskList.search, this.taskList.filter, this.taskList.period);
            Utils.showSuccessSnackbar(this.$t('book/facility:facility.dashboard.task-list.snackbar.reject-process'));
          },
          (error) => {
            this.$logger.info("Error at rejecting Process Job: " + error);
          }
        )
      }
    }
  },
  created() {
    ProcessService.readAllFromAPI(
      (resP) => {
        this.allProcesses = DataUtils.parseDataToObjectArray(resP.data, Process);
      },
      (error) => {
        this.$logger.error(error);
      }
    )
  }
}
</script>